<template>
    <client-page>
        <sub-visual subTab sh="About us" index="03" total="04" tabActive="Organization" bg="/images/sub/visual/sv1.jpg"> </sub-visual>

        <section class="section section--first section--last">
            <v-container>
                <div class="tit-wrap">
                    <h2 class="tit tit--lg dot-tit">Organization</h2>
                </div>

                <v-img width="100%" src="/images/sub/aboutus/organization-img.png" class="d-none d-md-block" />
                <v-img width="100%" src="/images/sub/aboutus/organization-m-img.png" class="d-md-none" />
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/en/sub/sub-visual.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
    },
};
</script>

<style lang="scss" scoped></style>
